import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function quizTopicDataReducer(
  state = initialState.quizTopicData,
  action
) {
  switch (action.type) {
    case types.LOADED_QUIZ_TOPIC_DATA_SUCCESS:
      return action.quizTopicData;
    default:
      return state;
  }
}
